"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _FilterGroup = _interopRequireDefault(require("./FilterGroup"));

var _GroupSeparator = _interopRequireDefault(require("./GroupSeparator"));

var _filterUtils = require("./utils/filterUtils");

var AudienceTargetingGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AudienceTargetingGroup, _Component);

  function AudienceTargetingGroup() {
    (0, _classCallCheck2.default)(this, AudienceTargetingGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AudienceTargetingGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(AudienceTargetingGroup, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(group) {
      var withSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var isUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          showFilterOptions = _this$props.showFilterOptions,
          hasScope = _this$props.hasScope,
          hideFilterOptions = _this$props.hideFilterOptions,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          addHideGroup = _this$props.addHideGroup,
          addFilter = _this$props.addFilter,
          removeFilter = _this$props.removeFilter,
          upgradeConfig = _this$props.upgradeConfig,
          updateFilter = _this$props.updateFilter;
      if (!group) return;
      var showValues = group.find(function (value) {
        return value.get('operator') !== 'NOT';
      });
      var hideValues = group.find(function (value) {
        return value.get('operator') === 'NOT';
      });
      var showIndex = group.findIndex(function (value) {
        return value.get('operator') !== 'NOT';
      });
      var hideIndex = group.findIndex(function (value) {
        return value.get('operator') === 'NOT';
      });
      var groupId = showValues ? showValues.get('groupId') : hideValues.get('groupId');
      var showRemoveEnabled = withSeparator;

      if (!showValues) {
        showRemoveEnabled = false;
        showValues = isUrl ? (0, _filterUtils.getDefaultUrlGroupFilter)(groupId) : (0, _filterUtils.getDefaultBlankFilter)(groupId);
      } // eslint-disable-next-line


      return _react.default.createElement(_UISection.default, {
        key: "show" + groupId,
        className: "targeting-options-group"
      }, withSeparator && _react.default.createElement(_GroupSeparator.default, {
        value: "and"
      }), _react.default.createElement(_FilterGroup.default, {
        addHideGroup: addHideGroup,
        addFilter: addFilter,
        filterOptions: showFilterOptions,
        filterPath: [0, 'values'],
        filterIndex: showIndex,
        filters: showValues.get('values'),
        groupId: groupId,
        hasHideGroup: Boolean(hideValues && hideValues.size),
        hasScope: hasScope,
        isShow: true,
        labelConfig: labelConfig,
        onChange: onChange,
        onBlur: onBlur,
        removeEnabled: showRemoveEnabled,
        removeFilter: removeFilter,
        upgradeConfig: upgradeConfig,
        updateFilter: updateFilter
      }), // eslint-disable-next-line
      Boolean(hideValues && hideValues.size) ? _react.default.createElement(_FilterGroup.default, {
        addFilter: addFilter,
        filterOptions: hideFilterOptions,
        filterPath: [0, 'values'],
        filterIndex: hideIndex,
        filters: hideValues.get('values'),
        groupId: groupId,
        hasScope: hasScope,
        isShow: false,
        labelConfig: labelConfig,
        onChange: onChange,
        onBlur: onBlur,
        removeEnabled: true,
        removeFilter: removeFilter,
        upgradeConfig: upgradeConfig,
        updateFilter: updateFilter
      }) : null);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var labelConfig = this.props.labelConfig;
      return _react.default.createElement(_UIHelpIcon.default, {
        title: labelConfig && labelConfig.websiteHelp
      });
    }
  }, {
    key: "renderSectionExplanation",
    value: function renderSectionExplanation(text, type) {
      var tooltip = type === 'website' ? this.renderIcon() : null;
      if (!text) return null;
      return _react.default.createElement("p", {
        className: type + "-explanation"
      }, text, tooltip);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          labelConfig = _this$props2.labelConfig,
          filterGroups = _this$props2.filterGroups,
          addSegment = _this$props2.addSegment;

      var addSegmentText = labelConfig.addSegment || _I18n.default.text(this.langKey('addSegment'));

      if (filterGroups.size === 0) {
        return null;
      }

      var websiteTitle = labelConfig.websiteTitle || _I18n.default.text(this.langKey('segments.url'));

      var behaviourTitle = labelConfig.behaviourTitle || _I18n.default.text(this.langKey('segments.behavior'));

      var behaviourText = labelConfig && labelConfig.behaviourExplanation;
      var websiteText = labelConfig && labelConfig.websiteExplanation;
      var urlGroup = filterGroups.filter(function (group) {
        return (0, _filterUtils.isURLType)(group.getIn([0, 'values', 0]));
      }).get(0);
      var behaviourGroups = filterGroups.filter(function (group) {
        return !(0, _filterUtils.isURLType)(group.getIn([0, 'values', 0]));
      });
      var h5websiteClass = websiteText ? 'title__with-text' : 'title__no-text';
      var h5BehaviourClass = behaviourText ? 'title__with-text' : 'title__no-text';
      return _react.default.createElement("div", {
        className: "m-bottom-15"
      }, _react.default.createElement("div", {
        className: "m-bottom-15"
      }, _react.default.createElement(_H.default, {
        className: h5websiteClass
      }, websiteTitle), this.renderSectionExplanation(websiteText, 'website'), this.renderGroup(urlGroup, false, true)), _react.default.createElement(_H.default, {
        className: h5BehaviourClass
      }, behaviourTitle), this.renderSectionExplanation(behaviourText, 'behaviour'), behaviourGroups.map(function (group, index) {
        return _this.renderGroup(group, index > 0);
      }), _react.default.createElement(_GroupSeparator.default, {
        className: "add-group"
      }), _react.default.createElement(_UIButton.default, {
        use: "tertiary",
        size: "small",
        onClick: function onClick() {
          return addSegment();
        }
      }, addSegmentText), this.props.children);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        children: _react.PropTypes.node,
        showFilterOptions: _react.PropTypes.object.isRequired,
        filterGroups: _react.PropTypes.instanceOf(_immutable.List).isRequired,
        hasScope: _react.PropTypes.bool.isRequired,
        hideFilterOptions: _react.PropTypes.object.isRequired,
        labelConfig: _react.PropTypes.object,
        onBlur: _react.PropTypes.func,
        onChange: _react.PropTypes.func,
        addSegment: _react.PropTypes.func.isRequired,
        addHideGroup: _react.PropTypes.func.isRequired,
        addFilter: _react.PropTypes.func.isRequired,
        removeFilter: _react.PropTypes.func.isRequired,
        upgradeConfig: _react.PropTypes.object.isRequired,
        updateFilter: _react.PropTypes.func.isRequired
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        onBlur: function onBlur() {}
      };
    }
  }]);
  return AudienceTargetingGroup;
}(_react.Component);

exports.default = AudienceTargetingGroup;
module.exports = exports.default;